export const WEB_FLIGHTS_LVE_DEAL_LANDING_PAGE = "web_flights_lve_deal_landing_page";
export const FLIGHT_DEALS_PREVIEW_QUERY_PARAM = "flight_deals_preview";
